import PropTypes from "prop-types";
import ResetPassword from "app/pages/Auth/ResetPassword/ResetPassword.jsx";
import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { resetPassword as resetPasswordAction } from "app/pages/Auth/AuthActions";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { HTTP_STATUS_CODES } from "app/constants";

const ResetPasswordContainer = () => {
	const { track } = useAnalytics();

	const { email } = useSelector(mapStateToProps, shallowEqual);
	// `email` is seeded client-side from a persisted Redux slice the server never sees, so using
	// it directly as Formik's initialValues would make the client's first render disagree with
	// the server-rendered HTML (empty) — React doesn't patch that kind of attribute mismatch after
	// hydration. Starting empty (matching SSR) and applying it post-mount lets the Formik
	// `enableReinitialize` pick it up as a normal, correctly-committed update instead.
	const [prefillEmail, setPrefillEmail] = useState("");

	useEffect(() => {
		if (email) {
			setPrefillEmail(email);
		}
	}, [email]);

	const dispatch = useDispatch();
	const resetPassword = useCallback(
		(...args) => dispatch(resetPasswordAction(...args)),
		[dispatch]
	);
	const handleSubmit = useCallback((values, { setErrors, setStatus }) => {
		const payload = {
			email: values.email,
		};

		return resetPassword(payload)
			.then(res => {
				if (res.status === 200) {
					setStatus({ success: true });
				} else {
					setStatus({ success: false });
					onSubmitFail(res, setErrors);
				}
			})
			.catch(error => {
				setStatus({ success: false });
				onSubmitFail(error, setErrors);
			});
	}, []);

	const onSubmitFail = useCallback((res, setErrors) => {
		let errorMessage;

		switch (res.status) {
			case HTTP_STATUS_CODES.NOT_FOUND:
				errorMessage = {
					id: "error.email.not.registered",
				};
				break;
			case HTTP_STATUS_CODES.TOO_MANY_REQUEST:
				errorMessage = {
					id: "error.email.too.many.request",
				};
				break;
			default:
				errorMessage = {
					id: "error.generic",
				};
				break;
		}

		// _error pour le composant AlertMessage. A refacto potentiellement
		setErrors({ _error: errorMessage });
		track("error", {
			error: `${res.config.method} ${res.config.url} : ${res.status} - ${res.statusText}`,
		});
	}, []);

	return (
		<ResetPassword
			handleSubmit={handleSubmit}
			initialValues={{
				email: prefillEmail,
			}}
		/>
	);
};

ResetPasswordContainer.propTypes = {
	resetPassword: PropTypes.func,
	email: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		email: state.email || "",
	};
};

export default ResetPasswordContainer;
